import { render, staticRenderFns } from "./WarningToken.vue?vue&type=template&id=90512dcc&scoped=true&"
import script from "./WarningToken.vue?vue&type=script&lang=js&"
export * from "./WarningToken.vue?vue&type=script&lang=js&"
import style0 from "./WarningToken.vue?vue&type=style&index=0&id=90512dcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90512dcc",
  null
  
)

export default component.exports